import { Modal, Switch, Typography, message } from 'antd'
import React, { useState } from 'react'
import { setCensusFileHiddenFromHR } from '../api/census-enrollment-platform-api-client'

const { Text } = Typography

function HideFromHRModal({
  open,
  publicKey,
  fileName,
  hiddenFromHR,
  onClose,
  onChanged,
}: {
  open: boolean
  publicKey: string
  fileName?: string
  hiddenFromHR: boolean
  onClose: () => void
  onChanged: (hiddenFromHR: boolean) => void
}) {
  const [isSaving, setIsSaving] = useState(false)

  const handleToggle = async (checked: boolean) => {
    setIsSaving(true)
    try {
      const updated = await setCensusFileHiddenFromHR(publicKey, checked)
      onChanged(updated.hiddenFromHR ?? checked)
      message.success(
        checked ? 'File hidden from HR view.' : 'File is now visible to HR.'
      )
      onClose()
    } catch (err: any) {
      const msg =
        err?.response?.data?.message ?? err?.message ?? 'Unknown error'
      message.error(`Failed to update file visibility: ${msg}`)
    } finally {
      setIsSaving(false)
    }
  }

  return (
    <Modal
      title="Hide From HR"
      open={open}
      onCancel={onClose}
      footer={null}
      destroyOnClose
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '16px',
        }}
      >
        <Text>
          Hide {fileName ? `"${fileName}"` : 'this file'} from HR / Customer
          Admin view. SureCo staff will still see it.
        </Text>
        <Switch
          checked={hiddenFromHR}
          loading={isSaving}
          onChange={handleToggle}
        />
      </div>
    </Modal>
  )
}

export default HideFromHRModal
